<template>
    <div class="wrapper-bg mission-collection">
        <div class="header-page">
            <a class="btn-back" @click="clickBack">
                <img src="@/assets/icon-back.svg" />
            </a>
            <span class="lbl-header">สะสมตลอดปีมีรางวัล</span>
        </div>
        <div class="main-layout coffee-nofooter">
            <div class="banner-container">
                <img
                    v-if="getUserlevel.userlevel === 'gold'"
                    src="@/assets/mission/glass-gold-new-theme.png"
                    alt=""
                    class="glass"
                />
                <img
                    v-else-if="getUserlevel.userlevel === 'silver'"
                    src="@/assets/mission/glass-silver-new-theme.png"
                    alt=""
                    class="glass"
                />
                <img
                    v-else
                    src="@/assets/mission/glass-brown-new-theme.png"
                    alt=""
                    class="glass"
                />
                <span class="glass-container">
                    <div>สะสมแล้ว</div>
                    <div class="glass-point">{{ getUserlevel.point }}</div>
                    <div class="glass-point">แก้ว</div>
                </span>
            </div>
            <div class="main-container">
                <div class="date-container">
                    <p>{{ dateCondition }}</p>
                </div>
                <div class="tab-container">
                    <div
                        @click="setActiveTab('reward')"
                        class="tab"
                        :class="{ active: activeTab == 'reward' }"
                    >
                        สิทธิพิเศษที่จะได้รับ
                    </div>
                    <div
                        @click="setActiveTab('condition')"
                        class="tab"
                        :class="{ active: activeTab == 'condition' }"
                    >
                        เงื่อนไข
                    </div>
                </div>
                <div class="white-line"></div>
                <div v-if="activeTab === 'reward'" class="text-box">
                    <ol class="modal-desc">
                        <li
                            v-for="(item, index) in reward[
                                getUserlevel.userlevel
                            ]"
                            :key="index"
                            class="desc-item"
                        >
                            <div class="number">{{ index + 1 }}.</div>
                            <div class="desc">{{ item }}</div>
                        </li>
                    </ol>
                </div>
                <div v-if="activeTab === 'condition'" class="text-box">
                    <ol class="modal-desc">
                        <li
                            v-for="(item, index) in condition[
                                getUserlevel.userlevel
                            ]"
                            :key="index"
                            class="desc-item"
                        >
                            <div class="number">{{ index + 1 }}.</div>
                            <div class="desc">{{ item }}</div>
                        </li>
                    </ol>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";
//helper
import Locale from "@/helper/locale/locale.js";
import CacheHelper from "@/helper/CacheHelper.js";
import DatetimeHelper from "@/helper/DatetimeHelper";
// import Account from "@/helper/AccountHelper.js";
//api//
import MenuApi from "@/module/Menu/service/missionbadge.js";
// import BzbsAuth from "@/core/Account/service/BzbsAuth.js";
//mixin
import Mixin from "@/mixin/Mixin";
//vuex
import { mapGetters } from "vuex";

export default {
    name: "MissionCollection",
    mixins: [Mixin],
    data: function () {
        return {
            cacheHelper: new CacheHelper(),
            lbl: Locale.getLbl(),
            reward: [],
            condition: [],
            activeTab: "reward",
            dateDetail: {
                from: "",
                to: "",
            },
            dateCondition: "",
        };
    },
    async created() {
        await this.getProfile();
        var getDetail = this.getDetail();
        // var updateUserlevel = this.updateUserlevel();
        this.handleLoading(true);

        Promise.all([getDetail])
            .then((values) => {
                console.log(values);
                this.handleLoading(false);
            })
            .catch((err) => {
                this.handleLoading(false);
                console.log(err.response);
            });
    },
    computed: mapGetters(["getUserlevel"]),
    methods: {
        getDetail() {
            return new Promise((resolve, reject) => {
                MenuApi.GetDetailBlob()
                    .then((response) => {
                        this.reward = response.data.reward;
                        this.condition = response.data.condition;
                        this.dateCondition = response.data.dateCondition;
                        this.dateDetail.to = DatetimeHelper.dateFullFormat(
                            response.data.dateDetail.to
                        );
                        this.dateDetail.from = DatetimeHelper.dateFullFormat(
                            response.data.dateDetail.from
                        );
                        console.log(this.dateDetail);
                        resolve(this.reward, this.condition);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        dateFormat(dateDetail) {
            let date = moment.unix(dateDetail).utc().format("D");
            let year = moment.unix(dateDetail).utc().format("YY");
            let month = moment.unix(dateDetail).utc().format("M");
            console.log(this.lbl.date.month_short);
            let formatedDate =
                date +
                " " +
                this.lbl.date.month_short[Number(month) - 1] +
                " " +
                (Number(year) + 43);
            // console.log(formatedDate)
            return formatedDate;
        },
        setActiveTab(tab) {
            this.activeTab = tab;
        },
        clickBack() {
            this.$router.push(`/privilege`);
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/module/Order/style/orderStyle.scss";
@import "@/module/Menu/style/mission.scss";
@import "@/style/_mixin.scss";

::v-deep.wrapper-bg {
    padding: 0;
}
.mission-collection {
    color: $color-brown-800;
    .banner-container {
        margin-top: 10px;
        display: flex;
        justify-content: center;
        position: relative;
        .glass {
            height: 205px;
        }
        .glass-container {
            color: $color-text;
            position: absolute;
            top: 100px;
            font-size: 14px;
            text-align: center;
            width: 69px;

            .glass-point {
                font-size: 18px;
                font-family: "PromptSemiBold";
            }
        }
    }

    .main-container {
        min-height: calc(100vh - 200px);
        background-color: $color-light-grey-500;
        border-top-left-radius: 20px;
        border-top-right-radius: 20px;
        padding: 70px 20px 20px;
        margin-top: -70px;
        .date-container {
            text-align: center;
            color: $color-brown-800;
            margin: 20px 0 30px;
            font-size: 14px;
        }
        .tab-container {
            display: flex;
            .tab {
                margin-right: 10px;
                padding: 4px 12px;
                color: $color-brown-900;
                border-bottom-right-radius: 30px;
                border-bottom-left-radius: 30px;
                border-top-left-radius: 30px;
                border-top-right-radius: 30px;
                &.active {
                    background-color: #fff;
                    color: $color-brown-900;
                }
            }
        }
        .text-box {
            overflow: auto;
        }
    }
    .desc-item {
        display: flex;
        margin-bottom: 10px;
        .number {
            margin-right: 10px;
        }
    }
    .white-line {
        height: 2px;
    }
}
</style>
